import React from 'react';

export interface EmptyStateProps {
  readonly title: string;
  readonly description?: string;
  readonly action?: React.ReactNode;
}

export function EmptyState({
  title,
  description,
  action,
}: EmptyStateProps): React.ReactElement {
  return (
    <div
      data-testid="empty-state"
      role="status"
      style={{
        padding: 48,
        textAlign: 'center',
        background: 'var(--color-bg-muted)',
        border: '1px dashed var(--color-border-default)',
        borderRadius: 8,
        color: 'var(--color-text-muted)',
      }}
    >
      <h3 style={{ marginTop: 0 }}>{title}</h3>
      {description && <p>{description}</p>}
      {action && <div style={{ marginTop: 16 }}>{action}</div>}
    </div>
  );
}
